import React from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { actions as userActions } from '../../store/user';
import { LoginComponent } from 'components';
const { refreshPasswordExpiration, resetPassword } = userActions;

const schema = {
  oldPassword: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      minimum: 8
    }
  },
  newPassword: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      minimum: 14
    },
    format: {
      pattern: '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!,@,%,$,*]).{14,}$',
      message:
        'should contain atleast one Uppercase letter, one Lower case letter, one Special character (!,@,%,$,*) and a Number'
    }
  },
  confirmPassword: {
    presence: { allowEmpty: false, message: 'is required' },
    equality: 'newPassword'
  }
};

const ResetPassword = props => {
  const { history } = props;
  const dispatch = useDispatch();

  const handleBack = () => {
    dispatch(refreshPasswordExpiration());
    history.push('/');
  };

  const handleReset = (event, values) => {
    event.preventDefault();
    dispatch(resetPassword(values));
  };

  const getInputFields = () => [
    { name: 'oldPassword', label: 'Current Password', type: 'password' },
    { name: 'newPassword', label: 'New Password', type: 'password' },
    { name: 'confirmPassword', label: 'Confirm Password', type: 'password' }
  ];

  const getButtonGroup = () => [
    {
      title: 'Submit',
      isSubmit: true,
      action: (event, values) => handleReset(event, values)
    },
    { title: 'Go to Sign in', action: handleBack, isEnabled: true }
  ];

  return (
    <LoginComponent
      title={'Reset Password'}
      subTitle={'Use your current password to reset'}
      inputFields={getInputFields()}
      buttonGroup={getButtonGroup()}
      schema={schema}
    />
  );
};

ResetPassword.propTypes = {
  history: PropTypes.object
};

export default withRouter(ResetPassword);
